import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { EyeVisible, ThumbsUp } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface RequestTypeDetailPageEmptyStateProps {
  onActionClick: () => void
  onPreviewClick: () => void
  isLoading?: boolean
}

const RequestTypeDetailPageEmptyState = ({
  onActionClick,
  onPreviewClick,
  isLoading = false,
}: RequestTypeDetailPageEmptyStateProps) => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Box style={{ whiteSpace: 'pre-line' }}>
        <OneEmptyState
          actions={[
            {
              icon: ThumbsUp,
              label: i18n.t('procurement.types.warning.button1'),
              onClick: isLoading ? () => {} : onActionClick,
              variant: 'outline',
            },
            {
              icon: EyeVisible,
              label: i18n.t('procurement.types.warning.button2'),
              onClick: onPreviewClick,
              variant: 'outline',
            },
          ]}
          description={i18n.t('procurement.types.warning.description')}
          emoji="🔒"
          title={i18n.t('procurement.types.warning.title')}
        />
      </Box>
    </Box>
  )
}

export default RequestTypeDetailPageEmptyState
